<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="凭证关联人" prop="username">
        <el-input v-model.trim="form.username" disabled="true" placeholder="" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="发票代码" prop="code">
        <el-input v-model.trim="form.code" placeholder="请输入发票代码" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="发票号码" prop="number">
        <el-input v-model.trim="form.number" placeholder="请输入发票号码" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="往来单位" prop="unit">
        <el-input v-model.trim="form.unit" placeholder="请输入往来单位" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="不含税金额" prop="no_tax_money">
        <el-input v-model.trim="form.no_tax_money" placeholder="请输入不含税金额" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="税额" prop="tax_money">
        <el-input v-model.trim="form.tax_money" placeholder="请输入税额" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="价税合计金额" prop="money">
        <el-input v-model.trim="form.money" placeholder="请输入价税合计金额" class="h-40 w-500"></el-input>
      </el-form-item>
      <el-form-item label="开票日期" prop="day">
        <el-date-picker
          class="h-40 w-500"
          v-model="form.day"
          type="date"
          placeholder="开票日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="发票文件">
        <object v-if="form.url.indexOf('pdf') != -1" :data="form.url" type="application/pdf" width="500px" height="388px"></object>
        <div v-if="form.url.indexOf('ofd') != -1" type="application/pdf" width="100px" height="50px" style="color:#111;line-height:50px;text-alias:center;">你已上传ofd文件，暂不支持查看</div>
        <el-popover
          v-if="form.url.indexOf('jpg') != -1 || form.url.indexOf('jpeg') != -1 || form.url.indexOf('png') != -1"
          placement="left-end"
          width="400"
          trigger="click">
          <img :src="form.url" width="100%">
          <img :src="form.url" width="150" height="100" style="cursor: pointer" class="m-r-10" slot="reference">
        </el-popover>
        <el-upload
        :action="uploadUrl"
        type="drag"
        :thumbnail-mode="true"
        :on-success="uploadSuccess"
        :on-error="uploadFail"
        show-file-list="false">
          <i class="el-icon-upload"></i>
          <div class="el-dragger__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传  pdf / ofd / jpg / png文件</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">保 存</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
		</el-form>
	</div>
</template>
<style>
	.form-checkbox:first-child{
		margin-left: 15px;
	}
  .item {
    margin: 4px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        fileList: [],
        propsImg: '',
        id: null,
        cost_list: [],
        city_list: [],
        pageCount: 0,
        form: {
          username: '',
          code: '',
          number: '',
          unit: '',
          no_tax_money: '',
          tax_money: '',
          money: '',
          day: '',
          url: ''
        },
        rules: {
          username: [
            { required: true, message: '请输入用户名' }
          ]
        }
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/invoice/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      uploadSuccess(res, file) {
        this.form.url = res.data
      },
      uploadFail(err, res, file) {
        console.log('err = ', _g.j2s(err))
        console.log('res = ', _g.j2s(res))
      },
      async getCompleteData() {
        this.apiGet('admin/invoice/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.username = data.username
            this.form.code = data.code
            this.form.number = data.number
            this.form.unit = data.unit
            this.form.no_tax_money = data.no_tax_money
            this.form.tax_money = data.tax_money
            this.form.money = data.money
            this.form.day = data.day
            this.form.url = data.url
          })
        })
      }
    },
    created() {
      this.uploadUrl = window.HOST + 'qiniu'
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?928547b4